import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';

const APP_TITLE: string = 'PIN Track ADMIN';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {

    constructor(private router: Router, private activatedRoute: ActivatedRoute, private titleService: Title) {
    }

    public ngOnInit(): void {
        // Name the current area in the page title so browser tabs and screen readers
        // can tell the areas apart.
        this.router.events.pipe(
            filter(event => event instanceof NavigationEnd),
            map(() => {
                let route: ActivatedRoute = this.activatedRoute;
                while (route.firstChild) {
                    route = route.firstChild;
                }
                return route.snapshot.data ? route.snapshot.data['title'] : null;
            })
        ).subscribe((title: string) => {
            this.titleService.setTitle(title ? `${title} – ${APP_TITLE}` : APP_TITLE);
        });
    }

}
